import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  footerText:string = "" ////ADD INE(JJGJ) 20221018 - REQ22978
  constructor() { }

  ngOnInit() {
  }

}
